import * as Yup from "yup";

export const dataModel = {
  company: "",
  year: "",
  period: "",
  date: "",
};

export const validationDataModel = Yup.object().shape({
  company: Yup.string().optional(""),
  year: Yup.number().optional(""),
  period: Yup.number().optional(""),
  date: Yup.date().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
